import type { EntryLocaleContent } from "../types";

/**
 * i18Next `entries:Game01.IDSA03` entry text content
 */
const IDSA03: EntryLocaleContent = {};

export default IDSA03;
